/**
 * ============================================================================
 * DizyPro ERP
 * Module : Service CRM
 * Feature: Installed Products
 *
 * File:
 * src/modules/service_crm/installed_products/constants/panelMaster.js
 *
 * Description:
 * Panel related master data used by Installed Product Management.
 *
 * Responsibilities:
 * - Panel Types
 * - Panel Makes
 * - Phase Types
 * - Cooling Types
 * - Plant Locations
 * - Commissioning Statuses
 *
 * NOTE:
 * These are frontend static masters.
 * Later they will be replaced by Master APIs.
 * ============================================================================
 */

/* ============================================================================
 * PANEL TYPES
 * ========================================================================== */

export const PANEL_TYPES = [
    { value: "", label: "Select" },
    { value: "STD", label: "STD" },
    { value: "AMF", label: "AMF" },
    { value: "AUTO_START", label: "Auto Start" },
    { value: "SPECIAL", label: "SPECIAL" },
    { value: "SYNC_PANEL", label: "SYNC PANEL" },
    { value: "OTHER_PANEL", label: "OTHER PANEL" },
    { value: "NA", label: "NA" }
];

/* ============================================================================
 * PANEL MAKES
 * ========================================================================== */

export const PANEL_MAKES = [
    { value: "", label: "Select" },
    { value: "JAKSON", label: "Jakson" },
    { value: "KIRLOSKAR", label: "Kirloskar" },
    { value: "OTHER", label: "Other" },
    { value: "NA", label: "NA" }
];

/* ============================================================================
 * PHASE TYPES
 * ========================================================================== */

export const PHASE_TYPES = [
    { value: "", label: "Select" },
    { value: "SINGLE_PHASE", label: "Single Phase" },
    { value: "THREE_PHASE", label: "Three Phase" },
    { value: "NA", label: "NA" }
];

/* ============================================================================
 * COOLING TYPES
 * ========================================================================== */

export const COOLING_TYPES = [
    { value: "", label: "Select" },
    { value: "WATER_COOL", label: "Water Cool" },
    { value: "AIR_COOL", label: "Air Cool" },
    { value: "NA", label: "NA" }
];

/* ============================================================================
 * PLANT LOCATIONS
 * ========================================================================== */

export const PLANT_LOCATIONS = [
    { value: "", label: "Select" },
    { value: "KAROLI", label: "Karoli" },
    { value: "SILVASSA", label: "Silvassa" },
    { value: "KIRLOSKAR", label: "Kirloskar" },
    { value: "NA", label: "NA" }
];

/* ============================================================================
 * COMMISSIONING STATUSES
 * ========================================================================== */

export const COMMISSIONING_STATUSES = [
    { value: "", label: "Select" },
    { value: "COMMISSIONED", label: "Commissioned" },
    { value: "INVOICED", label: "Invoiced" },
    { value: "ON_HAND", label: "On Hand" },
    { value: "OTHER", label: "Other" },
    { value: "NA", label: "NA" }
];